import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { CustomPicker } from "react-color";
import Alpha from "react-color/lib/components/common/Alpha";
import SketchPresetColors from "react-color/lib/components/sketch/SketchPresetColors";
import IconButton from "@mui/material/IconButton";
import GestureIcon from "@mui/icons-material/Gesture";
import theme from "~/themes/mildenberger";

const ColorPickerWrapper = styled("div")`
  width: 200px;
  padding: 10px 10px 0;
  box-sizing: initial;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.15);
  & > div {
    border: none !important;
  }
  & > .flexbox-fix > div > span > div[title="${props => props.color}"] {
    box-shadow: ${props => props.color} 0px 0px 4px !important;
  }
`;

const AlphaWrapper = styled("div")`
  position: relative;
  height: 10px;
  overflow: hidden;
`;

const AlphaSlider = styled(Alpha)`
  border-radius: 2px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15), inset 0 0 4px rgba(0, 0, 0, 0.25);
`;

const StrokeWidthWrapper = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

const StyledIconButton = styled(IconButton)(() => ({
  flexGrow: 1,
  borderRadius: "4px !important",
  margin: "12px 0",
  padding: 0,
  width: 40,
  height: 40,
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

function ColorPicker({
  presetColors,
  strokeWidths,
  onChange,
  onSwatchHover,
  rgb,
  hsl,
  renderers,
  strokeWidth,
  onStrokeWidthChange,
  classes,
  hex
}) {
  function getIconStyle(iteration) {
    return {
      fontSize: `${10 + iteration * 4}px`
    };
  }

  // function getIconButtonClasses() {
  //   return {
  //     root: classes.iconButtonRoot
  //   };
  // }

  function getIconButtonStyle(_strokeWidth) {
    return {
      border: strokeWidth === _strokeWidth ? "1px solid" : "1px solid transparent"
    };
  }

  function getIconColor(_strokeWidth) {
    return strokeWidth === _strokeWidth ? "primary" : "default";
  }

  function setStrokeWidth(_strokeWidth) {
    return () => onStrokeWidthChange(_strokeWidth);
  }

  console.log("strokeWidths", strokeWidths);

  return (
    <ColorPickerWrapper color={hex}>
      <SketchPresetColors colors={presetColors} onClick={onChange} onSwatchHover={onSwatchHover} />
      <AlphaWrapper>
        {/* TODO: Slider barrierefrei steuerbar */}
        <AlphaSlider rgb={rgb} hsl={hsl} renderers={renderers} onChange={onChange} />
      </AlphaWrapper>
      <StrokeWidthWrapper>
        {strokeWidths.map((sw, i) => (
          <StyledIconButton
            aria-label={`Strichstärke ${sw}`}
            key={sw}
            style={getIconButtonStyle(sw)}
            onClick={setStrokeWidth(sw)}
            color={getIconColor(sw)}
            size="large"
          >
            <GestureIcon style={getIconStyle(i)} />
          </StyledIconButton>
        ))}
      </StrokeWidthWrapper>
    </ColorPickerWrapper>
  );
}

ColorPicker.propTypes = {
  presetColors: PropTypes.array,
  strokeWidths: PropTypes.array,
  onChange: PropTypes.func,
  onSwatchHover: PropTypes.func,
  rgb: PropTypes.shape({}),
  hsl: PropTypes.any,
  renderers: PropTypes.any,
  strokeWidth: PropTypes.number.isRequired,
  onStrokeWidthChange: PropTypes.func.isRequired,
  classes: PropTypes.shape({})
};

ColorPicker.defaultProps = {
  presetColors: [
    "#e63312",
    "#f5a623",
    "#f8e71c",
    "#8b572a",
    "#7ed321",
    "#417505",
    "#ff8cf8",
    "#9013fe",
    "#1b649e",
    "#73b8fb",
    "#50e3c2",
    "#b8e986",
    "#000000",
    "#4a4a4a",
    "#9b9b9b",
    "#ffffff"
  ],
  strokeWidths: [2, 4, 8, 16, 24]
};

export default CustomPicker(ColorPicker);
